import { useState, useEffect, useRef } from "react";
import "./App.css";
import logo from "./assets/Home/Logo.png";
import { Mail } from "lucide-react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import {
  TranslationProvider,
  LangContext,
  LangToggleContext,
  useLang,
  useLangToggle,
  LangToggle,
} from "./TranslationProvider";

// ── DATA ─────────────────────────────────────────────────────────────────────

const NAV_ITEMS = [
  { label: "Vinyl Shop", href: "#" },
  { label: "Artists", href: "#" },
  {
    label: "Music",
    children: [
      "Vinyl",
      '7" Vinyl',
      "CDs",
      "Cassettes",
      "Box Sets",
      "Test Pressings",
      "Signed Music",
      "Soundtracks",
      "",
    ],
  },
  {
    label: "Merch",
    children: [
      "Tops",
      "Sweatshirts",
      "Outerwear",
      "Headwear",
      "Accessories",
      "Posters",
      "",
    ],
  },
  { label: "Exclusives", href: "#" },
  {
    label: "Collections",
    children: [
      "Signed Music",
      "New Arrivals",
      "GRAMMY® Nominees",
      "Definitive Sound Series",
      "2Pac x LA Kings",
      "Homecoming Szn",
      "Vintage",
      "Gallery Vinyl",
      "Staff Picks",
    ],
  },
  {
    label: "Vinyl Collective",
    children: ["Subscribe Now", "Archive", "Reserves Store", "FAQ"],
  },
  { label: "Lost Highway", href: "#" },
];

const HERO_SLIDES = [
  { bg: "/image1.jpeg?v=1", label: "Projects in México" },
  { bg: "/image2.jpeg?v=1", label: "Projects in México" },
  { bg: "/image3.jpeg?v=1", label: "Projects in México" },
  { bg: "/image5.jpeg?v=1", label: "Projects in México" },
];

const NEW_ARRIVALS = [
  {
    img: "/img7.jpeg",
    artist: "TRAVIS SCOTT",
    title: " CIRCUS MAXIMUS TOUR",
    tags: [],
  },
  {
    img: "/img8.jpeg",
    artist: "ARCANGEL",
    title: "OFFICIAL AFTERPARTY",
    tags: [],
  },
  {
    img: "/img9.jpeg",
    artist: "YOUNG MIKO",
    title: "OFFICIAL AFTERPARTY",
    tags: [],
  },
  {
    img: "/img10.jpeg",
    artist: "KEVIN ROLDAN",
    title: "OFFICIAL AFTERPARTY",
    tags: [],
  },
  {
    img: "/img11.jpeg",
    artist: "LUNAY",
    title: "OFFICIAL AFTERPARTY",
    tags: [],
  },
  {
    img: "/img12.jpeg",
    artist: "MARCA REGISTRADA",
    title: "FULL SHOW PAPANTLA",
    tags: [],
  },
  {
    img: "/img13.jpeg",
    artist: "NEGUZZ",
    title: "SPECIAL GUEST FESTIVAL VV",
    tags: [],
  },
  {
    img: "/img14.jpeg",
    artist: "POLIMÁ WESTCOAST",
    title: "SPECIAL GUEST ",
    tags: [],
  },

  {
    img: "/img16.jpeg",
    artist: "LUIS R. CONRIQUEZ",
    title: "OFFICIAL AFTERPARTY",
    tags: [],
  },
  {
    img: "/img17.jpeg",
    artist: "MS NINA",
    title: "SPECIAL GUEST ",
    tags: [],
  },
  {
    img: "/img18.jpeg",
    artist: "DANTE V",
    title: "SPECIAL GUEST ",
    tags: [],
  },
  {
    img: "/img19.jpeg",
    artist: "MC KLOPEDIA",
    title: "SPECIAL GUEST ",
    tags: [],
  },
  {
    img: "/img20.jpeg",
    artist: "YNG LVCAS",
    title: "FULL SHOW FESTIVAL VV",
    tags: [],
  },
  {
    img: "/img21.jpeg",
    artist: "CHASE B",
    title: "OFFICIAL AFTERPARTY",
    tags: [],
  },
];

const EXCLUSIVES = [
  {
    img: "/CAMPAIGN DESING1.jpeg",
    artist: "Bryantt Myers",
    title: "Lettering Design",
    tags: [""],
  },
  {
    img: "/CAMPAIGN DESING2.jpeg",
    artist: "DEI V",
    title: "Lettering Design",
    tags: [""],
  },
  {
    img: "/CAMPAIGN DESING3.jpeg",
    artist: "SKT",
    title: "Lettering Design",
    tags: [""],
  },
  {
    img: "/CAMPAIGN DESING4.jpeg",
    artist: "Patrón 970",
    title: "Cover + Lettering Design",
    tags: [""],
  },
  {
    img: "/CAMPAIGN DESING5.jpeg",
    artist: "Patrón 970",
    title: "Lettering Design",
    tags: [""],
  },
  {
    img: "/CAMPAIGN DESING6.jpeg",
    artist: "Young Sarria",
    title: "Cover + Lettering Design",
    tags: [""],
  },
  {
    img: "/CAMPAIGN DESING9.jpeg",
    artist: "LIT CULTURE",
    title: "COVER + EXCLUSIVE DESIGN",
    tags: [""],
  },
  {
    img: "/CAMPAIGN DESING7.jpeg",
    artist: "FESTIVAL VV",
    title: "Cover + Lettering Design",
    tags: [""],
  },
  {
    img: "/CAMPAIGN DESING8.jpeg",
    artist: "Low Wine",
    title: "Cover Design",
    tags: [""],
  },
];

const ARTISTS = [
  {
    name: "Anuel",
    img: "/artists1.jpeg",
  },
  {
    name: "The Game",
    img: "/artists2.jpeg",
  },
  {
    name: "Tempo",
    img: "/artists3.jpeg",
  },
  {
    name: "Bryantt Myers",
    img: "/artists4.jpeg",
  },
  {
    name: "Dei V",
    img: "/artists5.jpeg",
  },
  {
    name: "Rick Ross",
    img: "/artists6.jpeg",
  },
  {
    name: "Dreii",
    img: "/artists7.jpeg",
  },
  {
    name: "Doeboy",
    img: "/artists8.jpeg",
  },
  {
    name: "Guap Tarantino",
    img: "/artists9.jpeg",
  },
  {
    name: "Future",
    img: "/artists10.jpeg",
  },
  {
    name: "Kanye West",
    img: "/artists11.jpeg",
  },
  {
    name: "Playboi Carti",
    img: "https://interscope.com/cdn/shop/files/PlayboiCartiArtistHub.png?v=1722971685&width=600",
  },
];

const FEATURED_TABS = [
  {
    products: [
      {
        img: "https://interscope.com/cdn/shop/files/EminemKamikazeTPPackshot.png?v=1765483808&width=600",
        title: "Kamikaze Test Pressing",
        price: "$99.98",
        tags: ["Sold out", "LIMITED QUANTITIES"],
      },
      {
        img: "https://interscope.com/cdn/shop/files/Eminem_CurtainCall.jpg?v=1770157046&width=600",
        title: "Curtain Call 2 Orange 2LP",
        price: "$65.00",
        tags: [],
      },
      {
        img: "https://interscope.com/cdn/shop/files/Eminem__Fuel.jpg?v=1753733158&width=600",
        title: 'Eminem - Fuel 7" Vinyl',
        price: "$15.00",
        tags: ["Sold out", "EXCLUSIVE"],
      },
      {
        img: "https://interscope.com/cdn/shop/files/Em-black-key_01.jpg?v=1730936467&width=600",
        title: "Shady Artisan Keycap (Black)",
        price: "$35.00",
        tags: [],
      },
      {
        img: "https://interscope.com/cdn/shop/files/Em-Red-key_01.jpg?v=1730936472&width=600",
        title: "Shady Artisan Keycap (Red)",
        price: "$35.00",
        tags: [],
      },
      {
        img: "https://interscope.com/cdn/shop/files/Eminem_Coupe.jpg?v=1754594776&width=600",
        title:
          "The Death of Slim Shady (Coup de Grâce) Standard Red & Blue Opaque Vinyl 2LP",
        price: "$39.98",
        tags: [],
      },
    ],
  },
];

const MARQUEE_TEXT = "MUSIC SHOP";

// ── COMPONENTS ────────────────────────────────────────────────────────────────

function ProductCard({ img, img2, title, artist, price, tags }) {
  const [hovered, setHovered] = useState(false);
  const { t } = useLang();
  return (
    <div
      className="product-card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="product-card__img-wrap">
        <img
          src={hovered && img2 ? img2 : img}
          alt={title}
          className="product-card__img"
          loading="lazy"
        />
      </div>
      <div className="product-card__info">
        {artist && <p className="product-card__artist">{artist}</p>}
        <p className="product-card__title">{t(title, title)}</p>
        {price && <p className="product-card__price">{price}</p>}
      </div>
    </div>
  );
}

function ProductCarousel({ items, seeAllImg, seeAllLabel, seeAllHref }) {
  const [showModal, setShowModal] = useState(false);
  const trackRef = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(true);
  const { t } = useLang();

  const scroll = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  const onScroll = () => {
    const el = trackRef.current;
    if (!el) return;
    setCanLeft(el.scrollLeft > 4);
    setCanRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 4);
  };

  return (
    <div className="carousel">
      <button
        className={`carousel__arrow carousel__arrow--left${!canLeft ? " carousel__arrow--hidden" : ""}`}
        onClick={() => scroll(-1)}
        aria-label="Anterior"
      >
        ‹
      </button>
      <div className="carousel__track" ref={trackRef} onScroll={onScroll}>
        {items.map((item, i) => (
          <ProductCard key={i} {...item} />
        ))}
        {showModal && (
          <div
            onClick={() => setShowModal(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.55)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "#fff",
                padding: "32px",
                width: "90%",
                maxWidth: "420px",
                borderRadius: "4px",
                position: "relative",
              }}
            >
              <button
                onClick={() => setShowModal(false)}
                style={{
                  position: "absolute",
                  top: 12,
                  right: 16,
                  background: "none",
                  border: "none",
                  fontSize: "22px",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
              <h3
                style={{
                  fontFamily: "Anton",
                  fontSize: "22px",
                  letterSpacing: "0.1em",
                  marginBottom: "20px",
                }}
              >
                {t("modalTitle", "NUEVO MENSAJE")}
              </h3>
              <div
                style={{
                  borderBottom: "1px solid #ddd",
                  padding: "10px 0",
                  marginBottom: "8px",
                  fontSize: "13px",
                  color: "#888",
                }}
              >
                {t("modalTo", "Para:")}{" "}
                <span style={{ color: "#000" }}>info@interplayworld.com</span>
              </div>
              <input
                placeholder={t("modalSubject", "Asunto")}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "12px",
                  border: "none",
                  borderBottom: "1px solid #ddd",
                  fontFamily: "Inter",
                  fontSize: "13px",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              <textarea
                placeholder={t("modalMessage", "Mensaje")}
                rows={5}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "16px",
                  border: "1px solid #ddd",
                  fontFamily: "Inter",
                  fontSize: "13px",
                  resize: "none",
                  boxSizing: "border-box",
                }}
              />
              <button
                style={{
                  width: "100%",
                  padding: "12px",
                  background: "#000",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  fontFamily: "Inter",
                  fontWeight: 600,
                  letterSpacing: "0.12em",
                  fontSize: "12px",
                }}
              >
                {t("modalSend", "ENVIAR")}
              </button>
            </div>
          </div>
        )}

        {seeAllImg && (
          <div className="carousel__see-all-card">
            <img src={seeAllImg} alt="" className="carousel__see-all-bg" />
            <div className="carousel__see-all-overlay">
              <p>{t(seeAllLabel, seeAllLabel)}</p>
              <a
                onClick={() => setShowModal(true)}
                style={{ color: "white", cursor: "pointer" }}
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        )}
      </div>
      <button
        className={`carousel__arrow carousel__arrow--right${!canRight ? " carousel__arrow--hidden" : ""}`}
        onClick={() => scroll(1)}
        aria-label="Siguiente"
      >
        ›
      </button>
    </div>
  );
}

function HeroSlider() {
  const [current, setCurrent] = useState(0);
  const { t } = useLang();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % HERO_SLIDES.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="hero">
      <div className="hero__slides">
        {HERO_SLIDES.map((slide, i) => (
          <div
            key={i}
            className={`hero__slide${i === current ? " hero__slide--active" : ""}`}
            style={{ backgroundImage: `url(${slide.bg})` }}
          >
            {slide.label && (
              <div className="hero__label">
                <a href="#" className="btn-primary">
                  {t("heroLabel", slide.label)}
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="hero__dots">
        {HERO_SLIDES.map((_, i) => (
          <button
            key={i}
            className={`hero__dot${i === current ? " hero__dot--active" : ""}`}
            onClick={() => setCurrent(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
      <button
        className="hero__nav hero__nav--prev"
        onClick={() =>
          setCurrent((c) => (c - 1 + HERO_SLIDES.length) % HERO_SLIDES.length)
        }
        aria-label="Anterior"
      >
        ‹
      </button>
      <button
        className="hero__nav hero__nav--next"
        onClick={() => setCurrent((c) => (c + 1) % HERO_SLIDES.length)}
        aria-label="Siguiente"
      >
        ›
      </button>
    </section>
  );
}

function ArtistCarousel() {
  const trackRef = useRef(null);
  const [hovered, setHovered] = useState(null);
  const { t } = useLang();

  const scroll = (dir) => {
    trackRef.current?.scrollBy({ left: dir * 280, behavior: "smooth" });
  };

  return (
    <section className="section">
      <div className="section__head">
        <h2 className="section__title">
          {t("artistsWorkedWith", "Artists we've worked with")}
        </h2>
        <a href="#" className="section__link section__link--hide-mobile">
          {t("viewAll", "VIEW ALL")}
        </a>
      </div>
      <div className="artist-carousel">
        <button
          className="carousel__arrow carousel__arrow--left"
          onClick={() => scroll(-1)}
        >
          ‹
        </button>
        <div className="artist-carousel__track" ref={trackRef}>
          {ARTISTS.map((a, i) => (
            <div
              key={i}
              className="artist-card"
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              <div className="artist-card__img-wrap">
                <img
                  src={a.img}
                  alt={a.name}
                  className="artist-card__img"
                  loading="lazy"
                />
              </div>
              <p className="artist-card__name">{a.name}</p>
            </div>
          ))}
        </div>
        <button
          className="carousel__arrow carousel__arrow--right"
          onClick={() => scroll(1)}
        >
          ›
        </button>
      </div>
    </section>
  );
}

function FeaturedArtists() {
  const [activeTab, setActiveTab] = useState(0);
}

function Marquee() {
  const text = Array(20).fill(MARQUEE_TEXT).join(" · ");
}

function DropBanners() {
  const { t } = useLang();
  return (
    <section className="sectionmovil">
      <div className="drop-banners">
        <div className="drop-banner">
          <img
            src="/DeiV.jpeg"
            alt="Legends Never Die"
            className="drop-banner__img"
          />
          <div className="drop-banner__body">
            <a className="drop-banner__eyebrow">
              {t("drop1Label", "Dei V, Cover Design by InterPlay E. Group")}
            </a>
          </div>
        </div>
        <div className="drop-banner">
          <img
            src="/Millaray.jpeg"
            alt="Vinyl Shop"
            className="drop-banner__img"
          />
          <div className="drop-banner__body">
            <a className="drop-banner__eyebrow">
              {t("drop2Label", "Millaray, Cover Design by InterPlay E. Group")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ShopBanners() {
  const items = [];
  return (
    <div className="shop-banners">
      {items.map((item, i) => (
        <div key={i} className="shop-banner">
          <img src={item.img} alt={item.label} className="shop-banner__img" />
          <div className="shop-banner__body">
            <p className="shop-banner__label">{item.label}</p>
            <a href="#" className="btn-outline">
              SHOP NOW
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── NAVBAR ────────────────────────────────────────────────────────────────────

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [openDrop, setOpenDrop] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileDrop, setMobileDrop] = useState(null);
  const { t } = useLang();
  const { lang, loading, onToggle } = useLangToggle();

  // Aplicar traducciones a los items del nav dinámicamente
  const navItemsTranslated = NAV_ITEMS.map((item) => ({
    ...item,
    label: t(item.label, item.label),
    children: item.children?.map((c) => (c === "" ? "" : t(c, c))),
  }));

  const isSubPage =
    location.pathname === "/group" || location.pathname === "/records";

  return (
    <header className="header">
      <div className="header__login-bar"></div>

      <div className="header__top">
        {isSubPage ? (
          <>
            <button
              onClick={() => navigate("/")}
              style={{
                flex: 1,
                background: "none",
                border: "#000000",
                color: "inherit",
                cursor: "pointer",
                fontFamily: "Space Mono, monospace",
                fontSize: "20px",
                letterSpacing: "0.07em",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              ←
            </button>
            <div className="Logo_Pagina">
              <img src="/Logo.png" alt="Logo" />
            </div>
            <div style={{ flex: 1 }} />
          </>
        ) : (
          <>
            {/* ── TRADUCTOR (reemplaza al buscador) ── */}
            <div
              className="header__search"
              style={{ display: "flex", alignItems: "center" }}
            >
              <LangToggle lang={lang} loading={loading} onToggle={onToggle} />
            </div>

            <div className="Logo_Pagina">
              <img src="/Logo.png" alt="Logo" />
            </div>
            <div className="header__logos">
              <a
                className="header__logo-box"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/group");
                }}
                style={{ cursor: "pointer" }}
              >
                <span className="logo-bot">{t("navGroup", "GROUP")}</span>
              </a>
              <a
                className="header__logo-box"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/records");
                }}
                style={{ cursor: "pointer" }}
              >
                <span className="logo-bot">{t("navRecords", "RECORDS")}</span>
              </a>
            </div>
          </>
        )}
      </div>
      {!isSubPage && (
        <nav className="header__nav">
          <span className="header__nav-link">
            {t(
              "navTagline",
              "Exclusive deals, music proyects, executive production & worldwide alliances.",
            )}
          </span>
        </nav>
      )}

      <div
        className={`header__mobile-menu${mobileOpen ? " header__mobile-menu--open" : ""}`}
      >
        <div className="header__mobile-inner">
          {navItemsTranslated.map((item, i) =>
            item.children ? (
              <div key={i}>
                <button
                  className="header__mobile-link header__mobile-link--parent"
                  onClick={() => setMobileDrop(mobileDrop === i ? null : i)}
                >
                  {item.label}
                  <span
                    className={`header__mobile-caret${mobileDrop === i ? " rotated" : ""}`}
                  >
                    ▾
                  </span>
                </button>
                {mobileDrop === i && (
                  <div className="header__mobile-sub">
                    {item.children.map((child, j) => (
                      <a
                        key={j}
                        href="#"
                        className="header__mobile-link header__mobile-link--child"
                      >
                        {child}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <a
                key={i}
                href={item.href || "#"}
                className="header__mobile-link"
              >
                {item.label}
              </a>
            ),
          )}
        </div>
      </div>
    </header>
  );
}

// ── APP ───────────────────────────────────────────────────────────────────────

function Footer() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <footer className="footer">
      <div className="footer__bottom">
        {/* Solo desktop */}
        <div className="footer__legal footer__legal--desktop">
          <a
            onClick={() => navigate("/group")}
            className="footer__legal-link"
            style={{ cursor: "pointer" }}
          >
            {t("footerGroup", "InterPlay Entertainment Group")}
          </a>
          <a href="#" className="footer__legal-link">
            -
          </a>
          <a href="#" className="footer__legal-link">
            {t("footerMain", "InterPlay Entertainment")}
          </a>
          <a href="#" className="footer__legal-link">
            -
          </a>
          <a
            onClick={() => navigate("/records")}
            className="footer__legal-link"
            style={{ cursor: "pointer" }}
          >
            {t("footerRecords", "InterPlay Entertainment Records")}
          </a>
        </div>

        {/* Solo mobile */}
        <div className="footer__legal footer__legal--mobile">
          <a
            onClick={() => navigate("/group")}
            className="footer__legal-link"
            style={{ cursor: "pointer" }}
          >
            {t("footerGroup", "InterPlay Entertainment Group")}
          </a>

          <a
            onClick={() => navigate("/records")}
            className="footer__legal-link"
            style={{ cursor: "pointer" }}
          >
            -
          </a>

          <a
            onClick={() => navigate("/records")}
            className="footer__legal-link"
            style={{ cursor: "pointer" }}
          >
            {t("footerRecords", "InterPlay Entertainment Records")}
          </a>
        </div>

        <p className="footer__copy">
          {t(
            "footerCopy",
            "InterPlay Entertainment - © Todos los derechos reservados.",
          )}
        </p>
      </div>
    </footer>
  );
}

function PageGroup() {
  const { t } = useLang();
  return (
    <div style={{ minHeight: "80vh", padding: "80px 16px" }}>
      {/* AQUÍ VA TU INTERFAZ DE GROUP */}
      <section className="dss-section">
        <div className="dss-section__text">
          <h2 className="dss-section__title">
            {t("groupWorkWith", "Work With Us")}
          </h2>
          <p className="dss-section__sub">
            <strong>{t("groupSub", "Luxury brands, artists, and more")}</strong>
          </p>
          <p className="dss-section__body dss-section__body--sm">
            {t(
              "groupBody1",
              "We work with select world class companies, operating from Mexico across more than seven countries since 2018, we choose to work exclusively with the best, providing a wide range of services primarily focused on the music industry.",
            )}
          </p>
          <p
            className="dss-section__body dss-section__body--sm"
            style={{ marginTop: "16px" }}
          >
            {t(
              "groupBody2",
              "Today, we are the home where projects for your favorite artists and premium brands come to life.",
            )}
          </p>
        </div>
        <div className="dss-section__img">
          <img src="/Group.jpeg" alt="Enema of the State DSS One-Step" />
        </div>
      </section>
    </div>
  );
}

function PageRecords() {
  const { t } = useLang();
  return (
    <div style={{ minHeight: "80vh", padding: "80px 16px" }}>
      {/* AQUÍ VA TU INTERFAZ DE RECORDS */}
      <section className="dss-section">
        <div className="dss-section__text">
          <h2 className="dss-section__title">
            {t("recordsTitle", "Label Division")}
          </h2>
          <p className="dss-section__sub">
            <strong>
              {t("recordsSub", "Bring Your Project to Life With Us")}
            </strong>
          </p>
          <p className="dss-section__body dss-section__body--sm">
            {t(
              "recordsBody",
              "Discover our catalog of worldwide Gold and Platinum producers, collaboration management, songwriting services, professional pre-release consulting, and collaborations with artists from our record division.",
            )}
          </p>
        </div>
        <div className="dss-section__img">
          <img src="/Records.jpeg" alt="Enema of the State DSS One-Step" />
        </div>
      </section>
    </div>
  );
}

function HomePage() {
  const { t } = useLang();
  return (
    <>
      <HeroSlider />
      {/* NEW ARRIVALS */}
      <section className="section">
        <div className="section__head">
          <h2 className="section__title">
            {t("sectionArtists", "Artists & Live Bookings")}
          </h2>
        </div>
        <ProductCarousel
          items={NEW_ARRIVALS}
          seeAllImg="/negro.jpeg"
          seeAllLabel="REQUEST AVAILABILITY"
          seeAllHref="#"
        />
      </section>

      {/* STORE EXCLUSIVES */}
      <section className="section">
        <div className="section__head">
          <h2 className="section__title section__title--campaigns">
            {t("sectionCreative", "Creative")}
            <span className="campaigns-break">
              {" "}
              {t("campaignBreak", "Campaigns & Design")}
            </span>
          </h2>
          <a className="section__link section__link--doeboy">
            {t("doeLabel", "Doe Boy - Epic Records")}
          </a>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 0,
            background: "#000",
          }}
        >
          <video
            src="/Video.mp4"
            autoPlay
            muted
            loop
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
          <img
            src="/gif.jpeg"
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
        <ProductCarousel
          items={EXCLUSIVES}
          seeAllImg="/negro.jpeg"
          seeAllLabel="INQUIRE NOW"
          seeAllHref="#"
        />
      </section>

      <DropBanners />
      <ArtistCarousel />

      {/* DEFINITIVE SOUND SERIES */}
      <section className="dss-section">
        <div className="dss-section__text">
          <p className="dss-section__eyebrow">
            {t("dssEyebrow", "[ InterPlay E. Group Partnering with ]")}
          </p>
          <h2 className="dss-section__title">
            {t("dssTitle", "Maestros Joyeros")}
          </h2>
          <p className="dss-section__sub">
            <strong>{t("dssSub", "Side by Side with Artists")}</strong>
          </p>
          <p className="dss-section__body dss-section__body--sm">
            {t(
              "dssBody1",
              "We have brought exclusive artists to Maestros Joyeros locations, including Young Miko, Polimá Westcoast, Kevin Roldán, and more.",
            )}
          </p>
          <p
            className="dss-section__body dss-section__body--sm"
            style={{ marginTop: "16px" }}
          >
            {t(
              "dssBody2",
              "A collaboration between companies born from the relationship between the CEOs of both brands, creating unique experiences such as the Circus Maximus Tour experience with Travis Scott.",
            )}
          </p>
        </div>
        <div className="dss-section__img">
          <img src="/jOYERO.jpeg" alt="Enema of the State DSS One-Step" />
        </div>
      </section>

      {/* PARTNERS & SPONSORS */}
      <section className="section">
        <div className="section__head">
          <h2 className="section__title section__title--campaigns">
            {t("sectionPartners", "Partners")}
            <span className="campaigns-break">
              {" "}
              {t("partnersBreak", "& Sponsors")}
            </span>
          </h2>
          <a className="section__link section__link--doeboy">
            {t("aeroLabel", "Aeroart 2023 & 2024 - México City")}
          </a>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 0,
            background: "#000",
          }}
        >
          <video
            src="/WhatsApp Video 2026-05-08 at 11.35.32 PM.mp4"
            autoPlay
            muted
            loop
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
          <img
            src="/WhatsApp Image 2026-05-08 at 11.33.54 PM.jpeg"
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </section>

      <FeaturedArtists />
      <Marquee />
      <ShopBanners />
    </>
  );
}

function AppContent() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/group" element={<PageGroup />} />
          <Route path="/records" element={<PageRecords />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      {/* TranslationProvider envuelve todo para que el contexto esté disponible en toda la app */}
      <TranslationProvider>
        <AppContent />
      </TranslationProvider>
    </BrowserRouter>
  );
}
